import { Barbecue_grill_Italian_pizza, cheesy_pan, chicken_cheesy, Chicken_pizza, chicken_tomato, Coriander_pizza, cream_chees, family_special, Italian_corn, Italian_cuisine_cheesy, Margherita_Sushi_Pizza, mixed_special, mushroom_tomato_pizza, Normandin_pizza, onion_carrot, pepperoni_pizza, Pizza_pie, plain_chicken, Sausage_Pizza, tomatos_crusty_pizza } from "../assets";

export const pizzas =[
    {
        id:1,
        name:"Italian Chessy",
        type:"veg",
        preview:`${Italian_cuisine_cheesy}`,
        description:"A classic favourite with juicy flavour.",
        price:170
    },
    {
        id:2,
        name:"Chicken Pizza",
        type:"non-veg",
        preview:`${Chicken_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:470
    },
    {
        id:3,
        name:"Chicken Tomato",
        type:"non-veg",
        preview:`${chicken_tomato}`,
        description:"A classic favourite with juicy flavour.",
        price:530
    },
    {
        id:4,
        name:"Normand Pizza",
        type:"veg",
        preview:`${Normandin_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:210
    },
    {
        id:5,
        name:"Pepperoni Pizza",
        type:"veg",
        preview:`${pepperoni_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:120
    },
    {
        id:6,
        name:"Plain Chicken",
        type:"non-veg",
        preview:`${plain_chicken}`,
        description:"A classic favourite with juicy flavour.",
        price:460
    },
    {
        id:7,
        name:"Tomatos Crusty",
        type:"veg",
        preview:`${tomatos_crusty_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:270
    },
    {
        id:8,
        name:"Coriander Pizza",
        type:"veg",
        preview:`${Coriander_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:330
    },
    {
        id:9,
        name:"Tangy Tomato",
        type:"veg",
        preview:`${mushroom_tomato_pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:360
    },{
        id:10,
        name:"Mixed Special",
        type:"veg",
        preview:`${mixed_special}`,
        description:"A classic favourite with juicy flavour.",
        price:478
    },
    {
        id:11,
        name:"Cheesy Pan",
        type:"veg",
        preview:`${cheesy_pan}`,
        description:"A classic favourite with juicy flavour.",
        price:370
    },
    {
        id:12,
        name:"Chicken Cheesy",
        type:"non-veg",
        preview:`${chicken_cheesy}`,
        description:"A classic favourite with juicy flavour.",
        price:784
    },
    {
        id:13,
        name:"Onion Carrot",
        type:"veg",
        preview:`${onion_carrot}`,
        description:"A classic favourite with juicy flavour.",
        price:150
    },
    {
        id:14,
        name:"Barbecue Grill",
        preview:`${Barbecue_grill_Italian_pizza}`,
        type:"veg",
        description:"A classic favourite with juicy flavour.",
        price:230
    
    },
    {
        id:15,
        name:"Margherita Sushi",
        type:"non-veg",
        preview:`${Margherita_Sushi_Pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:160
    },
    {
        id:16,
        name:"Cream and Cheese Pizza",
        type:"veg",
        preview:`${cream_chees}`,
        description:"A classic favourite with juicy flavour.",
        price:140
    },
    {
        id:17,
        name:"Family special",
        type:"veg",
        preview:`${family_special}`,
        description:"A classic favourite with juicy flavour.",
        price:870
    },
    {
        id:18,
        name:"Sausage Pizza",
        type:"non-veg",
        preview:`${Sausage_Pizza}`,
        description:"A classic favourite with juicy flavour.",
        price:650
    },
    {
        id:19,
        name:"Italian Corn",
        type:"veg",
        preview:`${Italian_corn}`,
        description:"A classic favourite with juicy flavour.",
        price:230
    }
    ,
    {
        id:20,
        name:"Pizza Pie",
        type:"veg",
        preview:`${Pizza_pie}`,
        description:"A classic favourite with juicy flavour.",
        price:350
    }
]
